import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import get from 'lodash/get';
import cn from 'classnames';
import CSSModules from 'react-css-modules';

import Label from '../common/Label';

import getModeratorTitle from '../../utils/communities/getModeratorTitle';
import { formatDateTime } from '../../utils/converters/dateConverters';
import { COMMUNITY_POST_UPDATED, COMMON } from '../../constants/strings';

import styles from './index.styl';

const Header = ({
  author,
  organization,
                  publishedAt,
  intl: { formatMessage },
  updated,
  isNewPost,
  onTitleClick,
}) => {
  const time = publishedAt && formatDateTime(publishedAt, formatMessage);

  const moderator = getModeratorTitle(author, formatMessage);
  const provider = get(author, 'user.providerRole');
  const updatedLabel = formatMessage(COMMUNITY_POST_UPDATED);

  return (
    <div styleName="header" className="relative">
      <div styleName="header__title">
        <div className="header__user">
          <div styleName="header__author">
            <div
              className={cn({ pointer: Boolean(onTitleClick) })}
              onClick={onTitleClick}
            >
              {get(author, 'user.aliasName')}
            </div>
            <If condition={provider}>
              <div styleName="header__author__secondary">{provider}</div>
            </If>
            <If condition={moderator}>
              <div styleName="header__author__secondary">{moderator}</div>
            </If>
          </div>
          <div styleName="header__organization">{organization}</div>
        </div>
        <div styleName="header__time">
          <span className="mr2">{time}</span>
          <If condition={updated} className="mr2">
            ({updatedLabel})
          </If>
          <If condition={isNewPost}>
            <Label
              text={formatMessage(COMMON.new)}
              additionalClass="uppercase"
            />
          </If>
        </div>
      </div>
    </div>
  );
};

Header.propTypes = {
  author: PropTypes.shape({
    id: PropTypes.number,
    user: PropTypes.shape({
      id: PropTypes.number,
      avatar: PropTypes.objectOf(PropTypes.string),
      aliasName: PropTypes.string,
    }),
    role: PropTypes.string,
  }),
  publishedAt: PropTypes.string,
  organization: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
  onTitleClick: PropTypes.func,
  updated: PropTypes.bool,
  isNewPost: PropTypes.bool,
};

Header.defaultProps = {
  author: {},
  publishedAt: '',
  organization: '',
  updated: false,
  isNewPost: false,
  onTitleClick: null,
};

export default injectIntl(CSSModules(Header, styles, { allowMultiple: true }));



// WEBPACK FOOTER //
// ./src/components/PostPreview/Header.jsx